import { SHEET_BUY, SHEET_BUY_PARAM, SHEET_CLOSE, SHEET_FIT, SHEET_PARAM, SHEET_SIZE } from "@shared/funnelFyp";

/** This page is inside a sheet over FYP videos (?shz_sheet=1, in a frame). Opened
 *  on its own in a tab, the same address behaves as a page. */
export function inSheet(search = window.location.search): boolean {
  let framed = false;
  try {
    framed = window.parent !== window;
  } catch {
    framed = true;
  }
  return framed && new URLSearchParams(search).get(SHEET_PARAM) === "1";
}

function tell(data: Record<string, unknown>) {
  if (inSheet()) window.parent.postMessage(data, window.location.origin);
}

/** The sheet closes, back on the video. */
export const closeSheet = () => tell({ type: SHEET_CLOSE });

/** The sheet takes the whole screen ("full") or goes back to its own height ("auto"). */
export const sheetSize = (size: "full" | "auto") => tell({ type: SHEET_SIZE, size });

/** The sheet's own height: the page's top, down to `px`. */
export const sheetFit = (px: number) => tell({ type: SHEET_FIT, px });

/** This product page is over a funnel's or a live's video: its Beli belongs to that page's checkout. */
export function buysInParent(search = window.location.search): boolean {
  return inSheet(search) && new URLSearchParams(search).get(SHEET_BUY_PARAM) === "1";
}

/** Beli: the funnel's or live's checkout opens over the video for this product. */
export const sheetBuy = () => tell({ type: SHEET_BUY });
